import { Box, Grid } from "@mui/material";
import "../../assets/styles/pages/Fleet/incidentsPage.css";
import ChargePopup from "../../components/Fleet/ChargePopup/ChargePopup";
import ChargesTable from "../../components/Fleet/ChargesTable/ChargesTable";

const ChargesPage: React.FC = () => {
  return (
    <Box className="incidents-page">
      <Grid container spacing={1} alignItems="center" justifyContent="center">
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box
            sx={{
              flexWrap: { xs: "wrap", lg: "nowrap" },
              flex: 1,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="center"
              sx={{ maxWidth: "600px" }}
            >
              <Grid item>
                <ChargePopup />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <ChargesTable />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ChargesPage;
